import { RowWithIdentifier } from "./row-identifier";

/**
 * Builds a default `onRowNavigate` handler that points to a row's detail view.
 *
 * `basePath` is the router base the table is mounted under (e.g.
 * `/masterdata/customer`). The returned path is prefixed with `~` so it is
 * resolved as absolute from the router root — this makes it correct both for
 * same-tab navigation (wouter) and when opened in a new tab via `window.open`,
 * which is not aware of the nested router base.
 *
 * Returns `undefined` for rows without a `uuid` so no navigation is triggered.
 */
export const createRowNavigatePath =
  <TData extends RowWithIdentifier>(basePath: string) =>
  (row: TData): string | undefined =>
    row.uuid ? `~${basePath}/${row.uuid}` : undefined;
